import { random } from "lodash";
import { FigureVarData } from "../types/FigureVarData";
import { FigureVarSettings } from "../types/FigureVarSettings";

/**
 * Add all required properties from settings to existing properties array
 *
 * @param propertiesSettings - settings defining required properties
 * @param existingProperties - existing properties to fill
 * @returns - filled properties array
 */
export const fillPropertiesArray = (
  propertiesSettings: FigureVarSettings[],
  existingProperties?: FigureVarData[],
): FigureVarData[] => {
  const newProperties = [...(existingProperties ?? [])];
  propertiesSettings.forEach((propSetting) => {
    if (!newProperties.find((p) => p.varName === propSetting.varName)) {
      newProperties.push({
        varName: propSetting.varName,
        value:
          propSetting.defaultValue ??
          (propSetting.varName === "seed" ? random(1, 100).toString() : ""),
      });
    }
  });
  return newProperties;
};
